import React from 'react';
import { useClinicalReports } from '../../clinical-reports/ClinicalReportsContext';
import ReportSectionHead from '../../head-doctor/reports/ReportSectionHead';
import NursingActsSynthesisPanel from '../../head-doctor/reports/NursingActsSynthesisPanel';

export default function MajorReportsOverviewPage() {
  const {
    reportFilters,
    copy: COPY,
    hasActiveAdvancedFilters,
    clearAdvancedFilters
  } = useClinicalReports();

  return (
    <>
      <ReportSectionHead
        badge={COPY.SUB_OVERVIEW}
        title={COPY.PAGE_OVERVIEW_TITLE}
        description={COPY.PAGE_OVERVIEW_DESC}
      />

      <NursingActsSynthesisPanel
        reportFilters={reportFilters}
        copy={COPY}
        hasActiveAdvancedFilters={hasActiveAdvancedFilters}
        onClearFilters={clearAdvancedFilters}
      />
    </>
  );
}
